export const mineralFertilisationNutrientsGraphTheme = {
    color: ['#413EDD', '#85A0FF', '#CBD6FF', '#FDD980', '#FFB34E'],
};
